import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * ListingTags component
 */
export default class ListingTags extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ListingTags',
    refs: ['template', 'list'],
    emits: ['change'],
  };

  /**
   *  Render tags
   * @param {Array} fields
   */
  render(fields) {
    const tags = fields
      .filter((field) => field.value && field.value !== '-1')
      .map((field) => ({
        el: field,
        label: field.options[field.selectedIndex].text,
      }));

    toggleClass(this.$el, 'hidden', tags.length === 0);

    this.$refs.list.innerHTML = '';

    tags.forEach((tag) => {
      const element = this.$refs.template.cloneNode(true);
      element.querySelector('span').innerHTML = tag.label;

      element.addEventListener('click', () => {
        tag.el.value = '-1';
        this.$emit('change');
      });

      this.$refs.list.append(element);
    });
  }
}
